import { Observable } from 'rxjs';

import { Layer, ResultPage } from '@mirage-projects/cw-models';

/**
 * Remote request parameters to get the list of layers
 */
export interface GetAllLayersParams {
    page: number;
    layer_type: string;
    ordering: string;
    page_size: number;
    onlyMyLayers: boolean;
}

/**
 * Abstract service definition to manage the layers endpoints
 */
export abstract class LayerService {
    /**
     * Get layer by id
     * @param id Layer id
     */

    abstract get(id: number): Observable<Layer>;

    /**
     * Get the list of layers
     * @param params Parameters to filter the list
     */
    abstract getAll(params: Partial<GetAllLayersParams>): Observable<ResultPage<Layer>>;

    /**
     * Delete a layer
     * @param layer The layer to delete
     */
    abstract delete(layer: Layer | { id: number }): Observable<any>;

    /**
     * Update a layer
     * @param layer The layer to update
     */
    abstract update(layer: Layer): Observable<Layer>;

    /**
     * Rename a layer
     * @param layer Layer to rename
     * @param newName The new name
     */
    abstract rename(layer: Layer, newName: string): Observable<Layer>;
}
